<template>
    <div @click="sheetVisible = true" >
        <div
            class="wx-logo center"
        >
            <img
                class="wxCodeContainer"
                :src="wxQrcodeCardUrl ?
                    wxQrcodeCardUrl:
                    '../../../static/img/default.png'"
                alt=""
            >
            <div v-if="wxQrcodeCardUrl === null" class="inline-block">
                <label id="uploadLabel" for="upload" class="block logo-tips first">
                    {{ menuTypes.clickToUpload }}
                    <!-- 上传组件 -->
                    <Upload :onFileChange="uploadWxCode"/>
                </label>
                <span class="block logo-tips">{{ menuTypes.WxQrcodeCard }}</span>
            </div>
        </div>
        <div class="tips text-align-left">
            <p>
            <span class="block">{{ menuTypes.toolTip }}</span>
            {{ menuTypes.userEditTooltip }}
            </p>
        </div>
        <!-- 从相册中选择 -->
        <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>
        <!-- 备用input -->
        <input
            style="visibility: hidden"
            id="uploadBackUp"
            type="file"
            accept="image/*"
            action="http://192.168.0.1:3000"
            method="post"
            @change="uploadWxCode"
        />
    </div>
</template>

<script>
import Upload from '../comm/Upload';

export default {
  props: ['menuTypes', 'uploadWxCode', 'wxQrcodeCardUrl'],
  name: 'UploadWxCode',
  data() {
    return {
        sheetVisible: false,
        actions: [
            {
                name: '更改微信名片',
                method: this.openAlbum
            }
        ],
    }
  },
  methods: {
      openAlbum() {
        // 触发上传头像
        if (document.getElementById("upload")) {
            document.getElementById("upload").click();
            return;
        }
        document.getElementById("uploadBackUp").click();
      },
  },
  components: {
    Upload
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$mainWidthSize: 220px;
.wx-logo {
    overflow: hidden;
    $size: 220px;
    width: $size;
    height: $size;
    margin: 10px auto;
    background-color: #F3F3F3;
    color: #000;
    font-size: 16px;
    .logo-tips {
    font-weight: 500;
    }
    .first {
        margin-top: 30px;
    }
}
.tips {
    color: #7F7F7F;
    width: $mainWidthSize;
    margin: 0 auto;
}
.wxCodeContainer {
    width: 100%;
    position: relative;
    top:50%; 
    left:50%;
    transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/userEditElement/UploadWxCode.vue